import { render, staticRenderFns } from "./activity-rank.vue?vue&type=template&id=15a8412c&scoped=true&"
import script from "./activity-rank.vue?vue&type=script&lang=js&"
export * from "./activity-rank.vue?vue&type=script&lang=js&"
import style0 from "./activity-rank.vue?vue&type=style&index=0&id=15a8412c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a8412c",
  null
  
)

export default component.exports